<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18TA9dK/CoverDesign.jpg?1684514919070" alt="This image is the cover for the book Dopo il tramonto, Tempo al tempo"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dopo il tramonto, Tempo al tempo
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Tempo al tempo, Libro 2</i></b></p><p>Sono passati due anni da quando Stefan Joss si è trasferito nel sud degli Stati Uniti per amore del rancher Rand Holloway. Stef ha cercato – con esitazione – di adeguarsi alla sua nuova vita, ma il vero amore non fila mai liscio come dovrebbe. Rand vuole che lui rimanga a casa al ranch, Stef vuole avere una rete di sicurezza nel caso Rand decida di sbarazzarsi di lui. Finalmente, dopo aver capito di essere stato ingiusto a dubitare di lui, Stef decide di impegnarsi sul serio con Rand e l’uomo è al settimo cielo.</p> <p>Quando Stef ha l’opportunità di provare il suo amore, non si tira indietro, mettendo a repentaglio la sua stessa vita. E Rand ha la possibilità di dimostrare che – a volte – la vita può sorprenderti quando meno te lo aspetti.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Calmes, N.A.M.
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3df39ef9